import api from '@utils/api';
import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
const RegisteredInStoreSendEmail = (props) => {
    const { t } = useTranslation();
    const sendEmail = () => {
        api.forgotPasswordSendMail(props.loginEmail);
        props.setLoginStep('registeredInStore');
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "row" },
            React.createElement("p", { className: !props.fromMinicart ? 'col-sm-8 primary-xs' : 'primary-xs', dangerouslySetInnerHTML: {
                    __html: t('login.registeredinstore.welcomeback', { 0: props.loginEmail }),
                } }),
            React.createElement("button", { onClick: () => props.setLoginStep('email'), className: classNames('link primary-xs', { 'col-sm-2': !props.fromMinicart }) }, t('login.editemail'))),
        React.createElement("div", { className: "row mt-24 send-email-registered" },
            React.createElement("button", { className: "button button--secondary primary-xs", onClick: () => sendEmail() }, t('login.registeredinstore.sendemail')))));
};
export default RegisteredInStoreSendEmail;
